<template>
  <CommonOverlay class="overlay">
    <div class="complete_title">住所登録</div>
    <CommonModal class="modal pack-confirm">
      <div>
        商品発送のため住所登録をお願いします。<br>
        住所不備があった際は着払いで再送になります。
      </div>
      <div class="address_area">
        <LabelInput class="label-input" :labelText="t('郵便番号')" :annotation="t('「−」ハイフンは不要です')">
          <div class="announce-area">
            <TextBox class="text-box zip-code" inputType="text" :value="zipCode" placeholder="0000000" maxlength="10"
              @handleTextInput="inputZipCode" @handleTextChange="changeZipCode" />
            <div class="announce">※ハイフンは不要です</div>
          </div>
          <ErrorMessage v-if="errorMessageZipCode" class="error-message" :message="errorMessageZipCode" />
        </LabelInput>
        <LabelInput class="label-input" labelText="都道府県" v-if="i18n_mode == 'jp'">
          <SelectBox class="select-box prefecture-id" :options="prefectureList" :selectedOption="prefectureId"
            placeholder="" @handleSelectChange="selectPrefectureId" />
          <ErrorMessage v-if="errorMessagePrefectureId" class="error-message" :message="errorMessagePrefectureId" />
        </LabelInput>
        <LabelInput class="label-input" :labelText="t('市区町村')">
          <TextBox class="text-box shiku" inputType="text" :value="shiku" placeholder=""
            @handleTextInput="inputShiku" />
          <ErrorMessage v-if="errorMessageShiku" class="error-message" :message="errorMessageShiku" />
        </LabelInput>
        <LabelInput class="label-input" :labelText="t('番地')">
          <TextBox class="text-box address" inputType="text" :value="address" :placeholder="t('番地を入力してください')"
            @handleTextInput="inputAddress" />
          <ErrorMessage v-if="errorMessageAddress" class="error-message" :message="errorMessageAddress" />
        </LabelInput>
        <LabelInput class="label-input" :labelText="t('建物名・部屋番号')" :annotation="t('配送トラブル防止のため、該当する場合は略さずに必ず記載して下さい。')">
          <TextBox class="text-box address" inputType="text" :value="building" :placeholder="t('建物名・部屋番号を入力してください')"
            @handleTextInput="inputBuilding" />
          <ErrorMessage v-if="errorMessageBuilding" class="error-message" :message="errorMessageBuilding" />
        </LabelInput>
      </div>
      <RoundButton
        class="bottom_btn"
        @handleRoundBtnClick="goToRegister"
        backgroundColor="#7f88a0"
      >登録する</RoundButton>
    </CommonModal>
  </CommonOverlay>
</template>

<script>
import CommonOverlay from '@/components/atoms/CommonOverlay.vue';
import CommonModal from '@/components/atoms/CommonModal.vue';
import t from '@/plugins/i18n';
import { mapGetters } from 'vuex';
import RoundButton from '@/components/atoms/RoundButton.vue';
import ErrorMessage from '@/components/atoms/ErrorMessage.vue';
import SelectBox from '@/components/atoms/SelectBox.vue';
import LabelInput from '@/components/molecules/LabelInput.vue';
import TextBox from '@/components/atoms/TextBox.vue';

export default {
  name: 'OnceMore',
  mixins: [t],
  components: {
    CommonOverlay,
    RoundButton,
    CommonModal,
    ErrorMessage,
    SelectBox,
    LabelInput,
    TextBox,
  },

  props: {
    skip: {
      type: Boolean,
      default: false,
    },
    isOpenResult: {
      type: Boolean,
    },
    isSkip: {
      type: Boolean,
      default: true,
    },
  },

  computed: {
    ...mapGetters({
      currentPack: 'pack/currentPack',
      prefectureList: 'prefecture/prefectureList',
      appendAddress: 'user/appendAddress',
      currentAddress: 'zipCode/currentAddress',
    }),
  },
  watch: {
    currentAddress(newVal) {
      if (newVal) {
        if (newVal.state === 200) {
          const { result } = newVal;
          this.selectPrefectureId(result[0].prefcode);
          this.inputShiku(`${result[0].address2}${result[0].address3}`);
        }
      }
    },
    appendAddress(newVal) {
      if (newVal) {
        if (newVal.state === 200) {
          this.$emit('handleSaveSuccess');
        } else {
          const {
            zipcode,
            pref_id: prefId,
            shiku, address,
            building,
          } = newVal.errors;
          this.errorMessageZipCode = zipcode ? zipcode[0] : null;
          this.errorMessagePrefectureId = prefId ? prefId[0] : null;
          this.errorMessageShiku = shiku ? shiku[0] : null;
          this.errorMessageAddress = address ? address[0] : null;
          this.errorMessageBuilding = building ? building[0] : null;
        }
      }
    },
  },

  data: () => ({
    zipCode: '',
    prefectureId: '',
    shiku: '',
    address: '',
    building: '',
    errorMessageZipCode: '',
    errorMessagePrefectureId: '',
    errorMessageShiku: '',
    errorMessageAddress: '',
    errorMessageBuilding: '',
  }),

  methods: {
    inputZipCode(zipCode) {
      this.zipCode = zipCode;
    },
    selectPrefectureId(prefectureId) {
      this.prefectureId = prefectureId;
    },
    inputShiku(shiku) {
      this.shiku = shiku;
    },
    inputAddress(address) {
      this.address = address;
    },
    inputBuilding(building) {
      this.building = building;
    },
    changeZipCode() {
      const zipCodeLength = 7;
      if (String(this.zipCode).length === zipCodeLength) {
        const postParams = {
          zipcode: this.zipCode,
        };
        this.$store.dispatch('zipCode/setCurrentAddress', { postParams });
      }
    },
    goToRegister() {
      if (!window.confirm('発送先に登録します。\nよろしいでしょうか？')) {
        return;
      }
      const postParams = {
        zipcode: this.zipCode,
        pref_id: this.prefectureId,
        shiku: this.shiku,
        address: this.address,
        building: this.building,
      };
      this.$store.dispatch('user/appendAddress', { postParams });
    },
  },
};
</script>
<style lang="scss" scoped>
.overlay {
  z-index: 9;
  flex-direction: column;
  background-color: rgba(63, 72, 97, 0.9);
  overflow-y: auto;
  z-index: 20;
  .complete_title {
    color: $white;
    font-size: 24px;
    font-weight: bold;
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    img {
      width: 50px;
    }
  }
  .address_area {
    margin-top: 20px;
  }
  .banner_base {
    width: 420px;
  }
  .pack-confirm {
    width: 420px;
    background-color: $white;
    margin-top: 10px;
    padding: 30px;
    border-radius: 10px;
    text-align: center;
    font-size: 14px;
    font-weight: bold;
    color: $black;
    .bottom_btn {
      margin-top: 20px;
      width: 200px;
      padding: 15px 0;
    }
  }
}
.header-mode {
  position: initial;
  width: auto;
  height: auto;
  .complete_title {
    justify-content: center;
  }
}
@media screen and (max-width: $tabletWidth) {
  .overlay {
    .banner_base {
      width: 370px;
    }
    .pack-confirm {
      width: 96%;
    }
  }
}
</style>
